import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

import type { NavbarItemsGroup } from '../types';

import { BasicGroupItemElement } from './BasicGroupItemElement';

interface GroupItemProps {
  item: NavbarItemsGroup;
}

export function GroupItem(props: GroupItemProps) {
  const { item } = props;

  return (
    <Popover key={item.name} className="relative">
      <PopoverButton className="flex items-center gap-x-1 text-sm/6 font-semibold text-neutral-900 ">
        {item.name}
        <ChevronDownIcon
          aria-hidden="true"
          className="size-5 flex-none text-neutral-400"
        />
      </PopoverButton>

      <PopoverPanel
        transition
        className="absolute top-full -left-8 z-10 mt-3 w-screen max-w-xs overflow-hidden rounded-3xl bg-white shadow-lg ring-1 ring-neutral-900/5 transition data-closed:translate-y-1 data-closed:opacity-0 data-enter:duration-200 data-enter:ease-out data-leave:duration-150 data-leave:ease-in"
      >
        <div className="p-4">
          {item.group.map((item) => (
            <BasicGroupItemElement key={item.name} item={item} />
          ))}
        </div>
      </PopoverPanel>
    </Popover>
  );
}
